// test432
(432 && 0);
